export const pages = [
  // {
  //   description: 'Image title page',
  //   component: 'IntroTitlePage',
  // },
  // {
  //   description: 'Image message page',
  //   component: 'IntroMessagePage',
  // },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/1.jpg',
        name: '',
        copy: [
          'A three-stone emerald cut ring weighing 14.74 carats accompanied by 1.65 carats of trapezoid side stones, set in platinum.', 
        ],
        pages: [1],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/2.jpg',
        name: '',
        copy: [
          'A beautiful riviera necklace featuring 33.28 carats of round brilliant diamonds, set in 18 karat white gold.', 
        ],
        pages: [2],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/3.jpg',
        name: '',
        copy: [
          'A GIA certified oval cut diamond weighing 7.49 carats surrounded by .75 carats of round brilliant diamonds, set in platinum.', 
          'A stunning pair of dangle earrings featuring 8.86 carats of pear shaped diamonds and 3.02 carats of round brilliant diamonds, set in 18 karat white gold.', 
        ],
        pages: [3, 4],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/4.jpg',
        name: '',
        copy: [
          'A sapphire necklace weighing 31.50 carats insapphires, surrounded by 8.30 carats of round brilliant diamonds, set in 18 karat white gold.', 
        ],
        pages: [5],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/5.jpg',
        name: '',
        copy: [
          'A tennis bracelet containing 29.87 carats of radiant cut diamonds, set in platinum.', 
          'A tennis bracelet featuring 20.05 carats of sapphires and 21.48 carats of asscher cut diamonds, set in platinum.', 
        ],
        pages: [6, 7],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/6.jpg',
        name: '',
        copy: [
          'A beautiful riviera necklace featuring 53.58 carats of round brilliant diamonds, set in platinum.', 
        ],
        pages: [8],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/7.jpg',
        name: '',
        copy: [
          'A ten-row diamond tennis bracelet weighing 66.21 carats of diamonds, set in 18 karat white gold.', 
        ],
        pages: [9],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/8.jpg',
        name: '',
        copy: [
          'A breathtaking necklace featuring a 14.02 carat heart-shaped fancy yellow diamond, complemented by 4.71 carats of diamonds, set in 18 karat yellow and white gold.', 
        ],
        pages: [10],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/9.jpg',
        name: '',
        copy: [
          'A pair of dangle earrings containing 11.59 carats of fancy yellow diamonds, also accentuated by 2.01 carats of diamonds, set in 18 karat white and yellow gold.', 
        ],
        pages: [11],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/10.jpg',
        name: '',
        copy: [
          'A tennis bracelet featuring 45.95 carats of emerald cut diamonds, set in platinum.', 
        ],
        pages: [12],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/11.jpg',
        name: '',
        copy: [
          'A fancy yellow tennis bracelet featuring 14.48 carats of alternating diamond shapes, set in 18 karat yellow gold.', 
          'A tennis bracelet featuring 35 cushion cut fancy yellow diamonds weighing a total of 24.03 carats, set in 18 karat yellow gold.', 
        ],
        pages: [13, 14],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/12.jpg',
        name: '',
        copy: [
          'A riviera necklace showcasing 77 cushion cut diamonds, weighing a total of 63.95 carats, set in platinum.', 
        ],
        pages: [15],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/13.jpg',
        name: '',
        copy: [
          'An emerald cut diamond bracelet weighing a total of 36.51 carats and set in platinum. Available in all carat weights.', 
          'An east to west emerald cut diamond bracelet weighing 19.99 carats and set in platinum. Available in all carat weights.', 
        ],
        pages: [16, 17],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/14.jpg',
        name: '',
        copy: [
          'A stunning 8.18 carat oval-shaped emerald adorned with 1.61 carats of diamonds, set in platinum.', 
          'An emerald cut band weighing a total of 3.09 carats, surrounded by 2.47 carats of diamonds, set in 18 karat yellow gold.', 
        ],
        pages: [18, 19],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/15.jpg',
        name: '',
        copy: [
          'An elegant pair of dangle earrings featuring 7.34 carats of pear shaped and round brilliant diamonds, set in platinum.', 
          'A stunning pair of dangle earrings featuring 9.08 carats of variously shaped diamonds, set in 18 karat white gold.', 
        ],
        pages: [20, 21],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/16.jpg',
        name: '',
        copy: [
          'A stunning diamond and emerald necklace weighing 19.58 carats of diamonds and 17.62 carats of emeralds, set in 18 karat white gold.', 
          'An alternating riviera necklace featuring 19.91 carats of emeralds and 10.67 carats of diamonds, set in 18 karat white gold.', 
        ],
        pages: [22, 23],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/17.jpg',
        name: '',
        copy: [
          'A tennis bracelet featuring 43 radiant cut diamonds weighing a total of 21.48 carats, set in 18 karat white gold.', 
          'A stunning oval tennis bracelet weighing a total of 23.94 carats of diamonds, set in platinum.', 
        ],
        pages: [24, 25],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/18.jpg',
        name: '',
        copy: [
          'A gorgeous riviera necklace featuring 37.17 carats of pink sapphires and 6.55 carats of round brilliant diamonds, set in 18 karat white gold.', 
        ],
        pages: [26],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/19.jpg',
        name: '',
        copy: [
          'Eternity band weighing a total of 11.09 carats of brilliant round diamonds, set in 14 karat white gold. Available in various carat weights.', 
          'A GIA certified eternity band weighing 11.77 carats of emerald cut diamonds, set in platinum.', 
        ],
        pages: [27, 28],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/20.jpg',
        name: '',
        copy: [
          'A one-of-a-kind, diamond necklace featuring 109.14 carats of round brilliant diamonds, set in platinum.', 
        ],
        pages: [29],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/21.jpg',
        name: '',
        copy: [
          'A show-stopping bangle containing 25.58 carats of sapphires and 4.60 carats of  diamonds, set in 18 karat white gold.', 
        ],
        pages: [30],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/22.jpg',
        name: '',
        copy: [
          'A stunning diamond necklace weighing 43.94 carats of asscher cut diamonds, set in 18 karat white gold.', 
          'A tennis bracelet featuring 40 asscher cut diamonds weighing a total of 17.50 carats, set in platinum.', 
          'An asscher cut diamond engagement ring weighing 10.59 carats and accentuated by 1.75 carats of diamonds, set in platinum. GIA certificate available upon request.', 
        ],
        pages: [31, 32, 33],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/23.jpg',
        name: '',
        copy: [
          'A pair of sapphire earrings weighing a total of 19.07 carats of sapphires surrounded by 2.31 carats of diamonds, set in 18 karat white gold.', 
        ],
        pages: [34],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/24.jpg',
        name: '',
        copy: [
          'A three-stone engagement ring featuring a GIA certified 11.02 carat cushion cut diamond accented with diamond side stones weighing a total of 4.08 carats, set in platinum.', 
        ],
        pages: [35],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/25.jpg',
        name: '',
        copy: [
          'A GIA certified diamond necklace comprised of 49.19 carats of pear shape, marquise and round brilliant diamonds, set in 18 karat white gold.', 
        ],
        pages: [36],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/26.jpg',
        name: '',
        copy: [
          'A stunning band containing 3.55 carats of rubies surrounded by 2.31 carats of diamonds, set in 18 karat white gold.', 
          'A tennis bracelet complete with 9.55 carats of rubies and 2.96 carats of diamonds, set in 18 karat white gold.', 
        ],
        pages: [37, 38],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/27.jpg',
        name: '',
        copy: [
          'A classic pair of in-and-out diamond hoops featuring 12.02 carats of emerald cut diamonds, set in 18 karat white gold.', 
        ],
        pages: [39],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/28.jpg',
        name: '',
        copy: [
          'A one-of-a-kind, diamond and ruby necklace featuring 22.35 carats of rubies and 31.25 carats of diamonds, set in 18 karat white gold.', 
        ],
        pages: [40],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/29.jpg',
        name: '',
        copy: [
          'A three-stone radiant cut diamond ring weighing a total of 6.60 carats, set in white gold.', 
        ],
        pages: [41],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/30.jpg',
        name: '',
        copy: [
          'A GIA certified 11.25 carat radiant cut fancy yellow diamond ring set in platinum with brilliant cut trapezoid side stones and a halo totaling 2.00 carats.', 
          'Fancy yellow cushion cut diamond ring weighing 22.42 carats, surrounded by 1.03 carats of round brilliant diamonds and set in platinum.', 
        ],
        pages: [42, 43],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/31.jpg',
        name: '',
        copy: [
          'A one-of-a-kind diamond necklace weighing 59.94 carats of pear shaped diamonds, set in 18 karat white gold.', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/32.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/33.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/34.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/35.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/36.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/37.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/38.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/39.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/40.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/41.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/42.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/43.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/44.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/45.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/46.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/47.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/48.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/49.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/50.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/51.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/52.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/53.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/54.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/55.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/56.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/57.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/58.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/59.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/60.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/61.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/62.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/63.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/64.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/65.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/66.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/67.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/68.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/69.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/70.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/71.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/72.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/73.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/74.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/75.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/76.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/77.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/78.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/79.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/80.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/81.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/82.jpg',
        name: '',
        copy: [
          '', 
        ],
        pages: [44],
    }
  },
  // {
  //   description: 'Contact Page',
  //   component: 'ContactPage',
  //   product: {
  //       image: '',
  //       name: '',
  //       copy: [
  //         '',
  //       ],
  //       pages: [],
  //   }
  // },
];

export const mobilePages = [
  // {
  //   description: 'Image title page',
  //   component: 'IntroTitlePage',
  // },
  // {
  //   description: 'Image message page',
  //   component: 'IntroMessagePage',
  // },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/3.png',
        name: '',
        copy: [
          'A GIA certified marquise cut diamond weighing 5.08 carats, accented by 0.38 carats of round brilliant diamonds, set in platinum.', 
          'A GIA certified emerald cut diamond weighing 5.35 carats, accented by 0.38 carats of round brilliant diamonds, set in 14 karat white gold.', 
        ],
        pages: [1, 2],
    },
    bgColor: '#093329',
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/5.png',
        name: '',
        copy: [
          'A one-of-a-kind carpet necklace showcasing 160.95 carats of round brilliant diamonds, set in 18 karat white gold.', 
        ],
        pages: [3],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/7.png',
        name: '',
        copy: [
          'A stunning tennis bracelet containing 32.30 carats of emerald cut diamonds and 8.27 carats of round brilliant diamonds, set in platinum.', 
          'A GIA certified emerald cut diamond weighing 9.67 carats, accompanied by tapered baguette side stones weighing a total of 1.02 carats, set in 18 karat white gold.', 
        ],
        pages: [4, 5],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/9.png',
        name: '',
        copy: [
          'A pair of dangle earrings containing 3.04 carats of fancy yellow radiant and round brilliant cut diamonds, accentuated by 3.36 carats of radiant and round brilliant cut diamonds, set in 18 karat white and yellow gold.', 
          'A pair of dangle earrings containing 3.48 carats of fancy yellow pear and round brilliant cut diamonds, accentuated by 1.98 carats of pear cut diamonds and 1.80 carats of round brilliant cut diamonds, set in 18 karat white and yellow gold.', 
        ],
        pages: [6, 7],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/11.png',
        name: '',
        copy: [
          'An eternity band weighing a total of 11.09 carats of round brilliant diamonds, set in 14 karat white gold. Available in various carat weights.', 
          'A GIA certified eternity band weighing 11.77 carats of emerald cut diamonds, set in platinum. Available in various carat weights.', 
        ],
        pages: [8, 9],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/13.png',
        name: '',
        copy: [
          'A pair of dangle earrings featuring 6.58 carats of pear shaped red rubies, surrounded by 1.42 carats of round brilliant diamonds, set in 18 karat white gold.', 
          'A one-of-a-kind riviera necklace showcasing 14.92 carats of pear shaped red rubies and 17.52 carats of round brilliant diamonds, set in 18 karat white gold.', 
        ],
        pages: [10, 11],
    },
    bgColor: '#1F1F21',
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/15.png',
        name: '',
        copy: [
          'A pair of dangle earrings featuring 6.65 carats of asscher cut green emeralds and 2.45 carats of asscher cut diamonds, set in platinum.', 
          'A three stone engagement ring featuring a GIA certified 5.02 carat round brilliant diamond, accented by 0.35 carats of tapered baguettes, set in 14 karat white gold.', 
          'A GIA certified eternity band containing 4.76 carats of green emeralds and 4.62 carats of emerald cut diamonds, set in platinum.', 
        ],
        pages: [12, 13, 14],
    },
    bgColor: '#093329',
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/17.png',
        name: '',
        copy: [
          'A tennis bracelet featuring 35 cushion cut fancy yellow diamonds weighing a total of 24.03 carats, set in 18 karat yellow gold.', 
        ],
        pages: [15],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/19.png',
        name: '',
        copy: [
          'A tennis bracelet featuring 36 emerald cut GIA certified diamonds weighing a total of 35.32 carats, set in platinum.', 
          'A riveria necklace featuring a total of 52.44 carats of graduating emerald cut diamonds, set in 18 karat white gold.', 
        ],
        pages: [16, 17],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/21.png',
        name: '',
        copy: [
          'A pair of dangle earrings featuring 22.46 carats of pear shaped green emeralds and 0.69 carats of round brilliant diamonds, set in 18 karat white gold.', 
        ],
        pages: [18],
    },
    bgColor: '#093329',
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/23.png',
        name: '',
        copy: [
          'A GIA certified oval cut diamond weighing 11.05 carats, accented by 0.65 carats of round brilliant diamonds, set in platinum.', 
        ],
        pages: [19],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/25.png',
        name: '',
        copy: [
          'Blancpain\'s Villeret Ultraplate featuring a stainless steel case and 100 hour power reserve on a beautiful leather and alligator strap.', 
          'Blancpain\'s Villeret Ultraplate, featuring an ultra slim steel case and 40 hour power reserve on a sleek black satin strap.', 
        ],
        pages: [20, 21],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/27.png',
        name: '',
        copy: [
          'A stunning ring containing an oval cut green emerald weighing 15.05 carats, surrounded by 3.43 carats of round brilliant and pear cut diamonds, set in platinum.', 
          'A gorgeous riviera necklace showcasing 114.31 carats of oval cut green emeralds, accentuated by 27.75 carats of various shapes of diamonds, set in 18 karat white gold.', 
        ],
        pages: [22, 23],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/29.png',
        name: '',
        copy: [
          'A pair of drop earrings featuring 10.01 carats of pear shaped diamonds and 4.80 carats of round brilliant diamonds, set in 18 karat white gold.', 
        ],
        pages: [24],
    },
    bgColor: '#220C33',
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/31.png',
        name: '',
        copy: [
          'An elegant tennis bracelet showcasing 5.24 carats of pink diamonds and 7.55 carats of round brilliant diamonds, set in 18 karat two tone gold.', 
          'A GIA certified diamond band featuring alternating light pink and white cushion cut diamonds weighing a total of 5.32 carats, set in platinum.', 
        ],
        pages: [25, 26],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/33.png',
        name: '',
        copy: [
          'A riviera necklace featuring 61.19 carats of multicolored sapphires, surrounded by 7.07 carats of round brilliant diamonds, set in 18 karat white gold.', 
        ],
        pages: [27],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/35.png',
        name: '',
        copy: [
          'Franck Muller\'s Vanguard Crazy Hours, featuring a titanium case and 42 hour power reserve on a hand sewn alligator strap.', 
          'Franck Muller\'s Cintree Curvex, featuring a stainless steel case featuring a quartz movement and sapphire crystals on a hand sewn alligator strap.', 
        ],
        pages: [28, 29],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/37.png',
        name: '',
        copy: [
          'A one-of-a-kind bracelet featuring 64.60 carats of bezel-set fancy intense yellow diamonds of various shapes, set in 18 karat yellow gold.', 
        ],
        pages: [30],
    },
    bgColor: '#1F1F21',
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/39.png',
        name: '',
        copy: [
          'A gorgeous pair of dangle earrings containing 13.69 carats of pear shaped diamonds, set in 18 karat white gold.', 
        ],
        pages: [31],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/41.png',
        name: '',
        copy: [
          'An elegant floral riviera necklace featuring 44.05 carats of round brilliant diamonds, set in 18 karat white gold.', 
          'A pair of dangle earrings featuring 8.06 carats of oval shaped red rubies and 7.42 carats of oval shaped diamonds, set in 18 karat two tone gold.', 
        ],
        pages: [32, 33],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/43.png',
        name: '',
        copy: [
          'A stunning ring featuring a GIA certified fancy intense purple-pink pear shaped diamond weighing 1.51 carats, accented by 1.58 carats of pear cut diamonds set in both 18 karat rose gold and platinum.', 
        ],
        pages: [34],
    },
    bgColor: '#220C33',
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/45.png',
        name: '',
        copy: [
          'A beautiful tennis bracelet showcasing 10.81 carats of fancy yellow diamonds, 8.28 carats of white diamonds, and 0.35 carats of fancy pink diamonds, set in 18 karat two tone gold.', 
        ],
        pages: [35],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/47.png',
        name: '',
        copy: [
          'A gorgeous necklace featuring 30.70 carats of various shapes of pink sapphires and 13.85 carats of various shapes of diamonds, set in 18 karat white gold.', 
        ],
        pages: [36],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/49.png',
        name: '',
        copy: [
          'A classic tennis bracelet containing 13.83 carats of various shapes of diamonds, set in 18 karat white gold.', 
        ],
        pages: [37],
    },
    bgColor: '#220C33',
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/51.png',
        name: '',
        copy: [
          'A three stone ring featuring a 3.87 carat green emerald, accompanied by emerald cut diamond side stones weighing a total of 1.05 carats, set in platinum and 18 karat yellow gold.', 
          'A pair of drop earrings containing 10.01 carats of GIA certified emerald cut diamonds, set in platinum.', 
        ],
        pages: [38, 39],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/53.png',
        name: '',
        copy: [
          'Hublot\'s Big Bang Unico featuring a satin-finished and polished titanium case and 72 hour power reserve on a blue structured lined rubber strap.', 
          'Hublot\'s Big Bang featuring a satin-finished stainless steel diamond accented case and a three to five year power reserve on a blue rubber and alligator strap.', 
        ],
        pages: [40, 41],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/55.png',
        name: '',
        copy: [
          'A pair of drop earrings containing 6.25 carats of pear shaped paraiba tourmaline and 1.53 carats of various shapes of diamonds, set in platinum.', 
          'A GIA certified three stone ring showcasing a 3.74 carat oval shaped paraiba tourmaline and 1.44 carats of various shapes of diamonds, set in platinum.', 
        ],
        pages: [42, 43],
    },
    bgColor: '#1F1F21',
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/57.png',
        name: '',
        copy: [
          'A beautiful bracelet featuring 38.45 carats of multicolored sapphires, surrounded by 7.70 carats of diamonds, set in 18 karat white gold.', 
        ],
        pages: [44],
    },
    bgColor: '#220C33',
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/59.png',
        name: '',
        copy: [
          'An eternity band containing 7.30 carats of emerald cut blue sapphires and 6.67 carats of GIA certified emerald cut diamonds, set in platinum.', 
          'An eternity band containing 14.27 carats of asscher cut blue sapphires and 7.06 carats of asscher cut diamonds, set in 18 karat white gold.', 
        ],
        pages: [45, 46],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/61.png',
        name: '',
        copy: [
          'A gorgeous four-row tennis bracelet containing 19.59 carats of asscher cut diamonds, set in 18 karat white gold.', 
        ],
        pages: [47],
    },
    bgColor: '#093329',
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/63.png',
        name: '',
        copy: [
          'An incredible necklace containing a pear shaped green emerald weighing 7.87 carats, accentuated by 24.47 carats of heart shaped diamonds and 0.63 carats of round brilliant diamonds, set in 18 karat white gold.', 
          'A stunning pair of dangle earrings featuring 10.68 carats of pear shaped green emeralds, accented by 3.18 carats of heart shaped diamonds and 1.04 carats of round brilliant diamonds, set in 18 karat white gold.', 
        ],
        pages: [48, 49],
    },
    bgColor: '#093329',
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/65.png',
        name: '',
        copy: [
          'A beautiful cuff bracelet featuring 47.07 carats of various shapes of fancy colored diamonds, set in 18 karat two tone gold.', 
        ],
        pages: [50],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/67.png',
        name: '',
        copy: [
          'A floral inspired necklace featuring 20.33 carats of pear shaped blue sapphires and 32.21 carats of various shapes of diamonds, set in 18 karat white gold.', 
        ],
        pages: [51],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/69.png',
        name: '',
        copy: [
          'A GIA certified fancy yellow cushion cut diamond weighing 6.70 carats paired with half moon side diamonds weighing a total of 1.30 carats, set 18 karat yellow gold and platinum.', 
          'A one-of-a-kind riviera necklace showcasing 20.40 carats of fancy yellow diamonds and 25.58 carats of various shapes of diamonds, set in 18 karat two tone gold.', 
          'A stunning pair of dangle earrings featuring 6.03 carats of fancy yellow diamonds, accented by 0.81 carats of diamonds, set in 18 karat two tone gold.', 
        ],
        pages: [52, 53, 54],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/71.png',
        name: '',
        copy: [
          'Zenith\'s CHRONOMASTER Original is crafted in a 38mm steel case, paired with the iconic tri-colour dial and a steel bracelet.', 
          'Zenith\'s DEFY Midnight Borealis, crafted in a 36mm steel case with a diamond-set bezel, featuring a guilloché engraved dial with a vertical colour gradient shifting from blue to green.', 
        ],
        pages: [55, 56],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/73.png',
        name: '',
        copy: [
          'A pair of chandelier earrings containing 10.94 carats of fancy cut diamonds, set in 18 karat white gold.', 
        ],
        pages: [57],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/75.png',
        name: '',
        copy: [
          'A GIA certified round brilliant cut diamond weighing a total of 7.04 carats, surrounded by 0.85 carats of diamonds, set in platinum.', 
          'A GIA certified band containing 16 radiant cut diamonds weighing a total of 9.16 carats, set in platinum.', 
        ],
        pages: [58, 59],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/77.png',
        name: '',
        copy: [
          'A tennis bracelet containing 29.87 carats of radiant cut diamonds, set in platinum.', 
          'A tennis bracelet featuring 20.05 carats of blue sapphires and 21.48 carats of asscher cut diamonds, set in platinum.', 
        ],
        pages: [60, 61],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/79.png',
        name: '',
        copy: [
          'An incredible necklace featuring 45.79 carats of green emeralds, accentuated by 7.60 carats of pear shaped diamonds, set in platinum.', 
          'A stunning riviera necklace featuring 37.11 carats of green emeralds and 10.31 carats of round brilliant diamonds, set in 18 karat white gold.', 
        ],
        pages: [62, 63],
    }
  },
  {
    description: 'Product Page',
    component: 'ProductPage',
    product: {
        image: '/img/luxury2022/mobile/81.png',
        name: '',
        copy: [
          'A radiant cut fancy light yellow diamond weighing 14.38 carats, accompanied by 2.18 carats of various shapes of diamonds, set in 18 karat two tone gold.', 
        ],
        pages: [64],
    },
    bgColor: '#1F1F21',
  },
];


// WEBPACK FOOTER //
// ./src/constants/data/pages.jsx